import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CellRenderer, CellRendererParams } from 'app/shared/components/smart-grid/core/interfaces/cell-renderer.interface';
import { QuotaAttributes } from '@albatrosdeveloper/ave-models-package';
import { DecimalFormatPipe } from 'app/pipes/decimal-company.pipe';

/**
 * Currency Cell Renderer
 *
 * Renders currency values with right alignment using DecimalFormatPipe
 *
 * @example
 * ```typescript
 * {
 *   field: 'unitPrice',
 *   headerName: 'Cuota',
 *   cellRenderer: CurrencyCellRendererComponent,
 *   minWidth: 120,
 *   cellClass: 'text-right'
 * }
 * ```
 */
@Component({
  selector: 'app-currency-cell-renderer',
  standalone: true,
  imports: [CommonModule, DecimalFormatPipe],
  template: `
    {{ params.value | decimalFormat }}
  `,
})
export class CurrencyCellRendererComponent implements CellRenderer<QuotaAttributes, number> {
  @Input() params!: CellRendererParams<QuotaAttributes, number>;
}
